import { IReportTypeAvailableFor } from '~/types/models/reportType';

export const reportTypes = [
  { label: 'Traveling', value: '1' },
  { label: 'Diagnosis', value: '2' },
  { label: 'Repair', value: '3' },
];

export const AvailabilityTypes: Record<string, keyof IReportTypeAvailableFor> = {
  CustomerConcern: 'concern',
  ServicePackage: 'package',
  Labor: 'labor',
};
